var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel',[_c('v-expansion-panel-header',[_c('v-col',{class:"pa-0 pa-sm-auto col-auto "+ (_vm.doubleIcon?"larger-icon-section":"standard-icon-section")},[_vm._t("icons")],2),_c('v-col',{staticClass:"pl-0 pl-sm-auto pr-0 pr-sm-auto"},[_vm._t("title")],2)],1),_c('v-expansion-panel-content',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }